import React, { useState } from "react";
import { motion } from 'framer-motion'
import { ConnectButton } from '@rainbow-me/rainbowkit';

const Swap = () => {

    return (
        <>

            <h1 className="title">
                Web3
            </h1>

            <motion.div className="container Swap"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <main className="main">

                    <div className="page-content">

                        <iframe style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '400px', width: '100%', minHeight: '70vh', height: '100%' }} src="https://flooz.trade?refId=sIFtI9?backgroundColor=transparent"></iframe>

                        <div className="coco">
                            <ConnectButton />
                        </div>

                    </div>

                </main>

            </motion.div>
        </>

    );
};

export default Swap
